export const ACTION_CODE = 'ACTIVITIES' + '_ACTION';
